import React, { FC, PropsWithChildren } from 'react'
import cx from 'classnames'
import RealmBusiness from 'svgs/realm-business'

const NewLayoutOuter: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div
      className="tw:flex tw:flex-col tw:gap-4 tw:items-center tw:justify-between tw:min-h-screen"
      style={{
        background: 'linear-gradient(171deg, rgba(190, 194, 251, 0.30) 9.53%, rgba(252, 246, 242, 0.00) 86.2%)',
      }}
    >
      {children}
    </div>
  )
}

const NewLayoutInner: FC<PropsWithChildren<{ size?: 'xl' | '4xl' }>> = ({ children, size = '4xl' }) => {
  return (
    <div className="tw:flex tw:flex-col tw:gap-4 tw:items-center tw:w-full tw:px-5">
      <div className="tw:pt-4">
        <RealmBusiness className="tw:h-10 tw:mx-auto" />
      </div>
      <div
        className={cx(
          'tw:flex tw:flex-col tw:gap-4 tw:px-4 tw:py-8 tw:pb-6 tw:bg-white tw:rounded-4xl tw:border tw:border-neutrals-300 tw:w-full',
          { 'tw:max-w-4xl': size == '4xl', 'tw:max-w-xl': size == 'xl' }
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default {
  Outer: NewLayoutOuter,
  Inner: NewLayoutInner,
}
